/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preview/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Html from './Html/index'
import No from './No/index'
import Pdf from './Pdf/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Preview({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/Payor/Content/Preview"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payorContractValueData = fromData.useDataFormat({ viewPath,
context: 'payor',
path: 'contract',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: payorContractValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Html'}>
<Html
  viewPath={`${viewPath}/Html`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Pdf'}>
<Pdf
  viewPath={`${viewPath}/Pdf`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}